export const AUTH_CONFIG = {
    domain:  process.env.REACT_APP_AUTH0_DOMAIN!,
    clientId: process.env.REACT_APP_AUTH0_CLIENT_ID!,
    clientSecret: process.env.REACT_APP_AUTH0_CLIENT_SECRET!,
    callbackUrl: process.env.REACT_APP_AUTH0_CALLBACK_URL,
    redirectUrl: process.env.REACT_APP_AUTH0_REDIRECT_URL
  };